export const getSettings = ({ Settings }) => Settings;

export const getOrderStatusCategory = (state) => getSettings(state).orderStatusCategory;
